<template>
<div class="grid"  @click="edit">
<div class="col-12 md:col-2">
<p class="click_edit_value_title">{{title}}:</p>
</div>


<template v-if="editing">
<div class="col-12 md:col-10 mt-3">
<div class="grid"  v-click-away="cancel">
<div class="col">

<InputText  type="text" v-model="inputdata" class="w-full p-inputtext-sm animate_class" :placeholder="title" v-on:keyup.enter="submitChanges"  v-on:keyup.esc="cancel" ref="inputarea"  />

</div>
<div class="col-fixed " style="width:110px">
<Button type="button"  icon="pi pi-check" @click="submitChanges" class="p-button-primary p-button-outlined p-button-sm mr-2"  :loading="$store.state.ui.submitting" />
<Button type="button"  icon="pi pi-times" @click="cancel" class="p-button-danger p-button-outlined p-button-sm "  :loading="$store.state.ui.submitting" />
</div>
</div>
</div>
</template>

<template v-if="!editing">	
<div class="col-12 md:col-10">
<p class="click_edit_value animate_class">
{{value}}
</p>
</div>
</template>

</div>	
</template>

<script>
export default {

  name: 'AuditorQuestionlistLine',
  props:["title","value","valkey"],
  data () {
    return {
    	editing:false,
    	inputdata:null,
    }
  },
  computed:{

  },
  watch:{
  	value(nevVal,oldVal)
  	{
  		 console.log("value change");
  		 this.editing = false
  	}
  },
  methods:{
  	submitChanges()
  	{

  		if(this.inputdata !==this.value)
  		{
  			this.$emit("dataChanged",{value:this.inputdata,key:this.valkey})
  			//this.cancel()
  		}
  		else
  		{
  			this.cancel()
  		}
  		
  	},
  	edit()
  	{
  		this.editing = true
  		this.inputdata = this.value
  		
  		setTimeout(()=>{
  			if(this.$refs.inputarea)
  			{
  				this.$refs.inputarea.$el.focus()
  			}
  			
  		},10)
  		
  	},
  	cancel()
  	{
  		setTimeout(()=>{
  			this.editing = false
  		},10)
  		
  	},

  }
};
</script>

<style lang="css" scoped>
</style>